export default "__VITE_ASSET__d1269f9d__"